import React, { useState } from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200" data-id="element-141">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-142">
        <span className="text-xl font-bold text-gray-900 pr-8" data-id="element-143">{question}</span>
        <ChevronDown className={`w-6 h-6 text-green-600 transform transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-144" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-145">
        <p className="text-lg text-gray-700 leading-relaxed" data-id="element-146">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    q: '¿Esto funciona igual para hombres y para mujeres?',
    a: 'Sí, absolutamente. El mecanismo de la glucosa y la insulina es biológicamente el mismo en hombres y mujeres. La Secuencia de Oro funciona para ambos géneros.'
  }, {
    q: '¿Puedo seguir comiendo tortillas, arroz y pan?',
    a: '¡Por supuesto! Ese es el mayor beneficio de este método. No eliminas tus carbohidratos favoritos, simplemente aprendes a comerlos al final de tu comida para minimizar su impacto en tu azúcar.'
  }, {
    q: '¿Cuánto tiempo tarda en funcionar?',
    a: 'Muchas personas notan cambios en sus niveles de energía y reducción de antojos desde el primer o segundo día de aplicar la secuencia. Es un cambio biológico casi inmediato.'
  }, {
    q: '¿Qué pasa si tengo prediabetes o diabetes?',
    a: 'Este eBook es estrictamente educativo y te ayudará a entender cómo los alimentos afectan tu glucosa. Sin embargo, si tienes una condición médica, siempre debes consultar a tu médico antes de hacer cambios en tu alimentación.'
  }, {
    q: '¿Necesito comprar alimentos especiales o costosos?',
    a: 'No. Usarás los mismos alimentos cotidianos que ya compras en el supermercado: pollo, huevos, vegetales, arroz, frijoles. No hay suplementos ni batidos mágicos que comprar.'
  }, {
    q: '¿Funciona si trabajo por turnos o tengo horarios irregulares?',
    a: 'Sí. La Secuencia de Oro se aplica a la comida que tienes frente a ti, sin importar si es la 1 de la tarde o las 3 de la mañana. Funciona adaptándose a tu horario.'
  }, {
    q: '¿Qué pasa si ya intenté otras dietas y fallé?',
    a: 'Esto no es una dieta, es una estrategia de orden de alimentos. No requiere contar calorías ni pasar hambre, por lo que es infinitamente más fácil de mantener a largo plazo que cualquier dieta tradicional.'
  }, {
    q: '¿Es apto para personas mayores de 50 años?',
    a: 'Totalmente. De hecho, a medida que envejecemos, nuestro cuerpo se vuelve más sensible a los picos de glucosa, por lo que este método se vuelve aún más valioso y efectivo.'
  }, {
    q: '¿Cuándo recibo el eBook después de comprar?',
    a: 'Inmediatamente. Una vez procesado tu pago seguro, serás redirigido a la página de descarga y también recibirás un correo con el enlace para descargar tu PDF al instante.'
  }, {
    q: '¿Qué pasa si no me funciona?',
    a: 'Tienes mi garantía incondicional de 30 días. Si aplicas el método y no sientes una mejora real en tu energía y control de antojos, me escribes y te devuelvo el 100% de tu dinero.'
  }];
  return <section className="py-16 md:py-24 bg-white px-4" data-id="element-147">
      <div className="max-w-3xl mx-auto" data-id="element-148">
        <FadeInSection data-id="element-149">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-150">
            Preguntas Frecuentes
          </h2>

          <div className="divide-y divide-gray-200" data-id="element-151">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-152" />)}
          </div>
        </FadeInSection>
      </div>
    </section>;
}